
//   // /dashboard/src/App.js

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './components/HomePage';
// import AdminLogin from './components/AdminLogin';
// import AdminDashboard from './components/AdminDashboard';
// import VolunteerLogin from './components/VolunteerLogin';
// import VolunteerDashboard from './components/VolunteerDashboard';
// import VolunteerReceiptPreview from './components/VolunteerReceiptPreview';
// import VolunteerUpdatePassword from './components/VolunteerUpdatePassword';
// import UserUpdatePassword from './components/UserUpdatePassword';  // <-- NEW import
// import ProtectedRoute from './components/ProtectedRoute';

// const NotFound = () => <h2 className="text-center text-xl mt-10">404 Not Found</h2>;
// const Unauthorized = () => <h2 className="text-center text-xl mt-10">Unauthorized</h2>;

// function App() {
//   return (
//     <Router>
//       <div className="min-h-screen flex flex-col">
//         <div className="flex-grow">
//           <Routes>
//             {/* Public/Home Route */}
//             <Route path="/" element={<HomePage />} />

//             {/* Admin routes */}
//             <Route path="/admin" element={<AdminLogin />} />
//             <Route
//               path="/admin/dashboard"
//               element={
//                 <ProtectedRoute roleRequired="admin">
//                   <AdminDashboard />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Volunteer routes */}
//             <Route path="/volunteer" element={<VolunteerLogin />} />
//             <Route
//               path="/volunteer/dashboard"
//               element={
//                 <ProtectedRoute roleRequired="volunteer">
//                   <VolunteerDashboard />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/volunteer/receipt-preview"
//               element={
//                 <ProtectedRoute roleRequired="volunteer">
//                   <VolunteerReceiptPreview />
//                 </ProtectedRoute>
//               }
//             />
//             {/* Existing volunteer-specific password update route */}
//             <Route
//               path="/volunteer/update-password"
//               element={
//                 <ProtectedRoute roleRequired="volunteer">
//                   <VolunteerUpdatePassword />
//                 </ProtectedRoute>
//               }
//             />

//             {/* NEW universal user update password route */}
//             <Route
//               path="/user/update-password"
//               element={
//                 // Allow any recognized role to access
//                 <ProtectedRoute roleRequired={['master_admin','admin','accounts','trustee','graphics','volunteer']}>
//                   <UserUpdatePassword />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Unauthorized / 404 */}
//             <Route path="/unauthorized" element={<Unauthorized />} />
//             <Route path="*" element={<NotFound />} />
//           </Routes>
//         </div>
//       </div>
//     </Router>
//   );
// }

// export default App;


// /dashboard/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import VolunteerLogin from './components/VolunteerLogin';
import VolunteerDashboard from './components/VolunteerDashboard';
import VolunteerReceiptPreview from './components/VolunteerReceiptPreview';
import VolunteerUpdatePassword from './components/VolunteerUpdatePassword';
import UserUpdatePassword from './components/UserUpdatePassword';
import ProtectedRoute from './components/ProtectedRoute';

const NotFound = () => <h2 className="text-center text-xl mt-10">404 Not Found</h2>;
// If you want to keep an "Unauthorized" page, you can, but we’ll be redirecting to Home if not authorized
const Unauthorized = () => <h2 className="text-center text-xl mt-10">Unauthorized</h2>;

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow">
          <Routes>
            {/* Public/Home Route */}
            <Route path="/" element={<HomePage />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute roleRequired="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* If you want admin to see the same receipt preview for offline donations: */}
            <Route
              path="/admin/receipt-preview"
              element={
                <ProtectedRoute roleRequired="admin">
                  <VolunteerReceiptPreview />
                </ProtectedRoute>
              }
            />

            {/* Volunteer routes */}
            <Route path="/volunteer" element={<VolunteerLogin />} />
            <Route
              path="/volunteer/dashboard"
              element={
                <ProtectedRoute roleRequired="volunteer">
                  <VolunteerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/volunteer/receipt-preview"
              element={
                <ProtectedRoute roleRequired="volunteer">
                  <VolunteerReceiptPreview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/volunteer/update-password"
              element={
                <ProtectedRoute roleRequired="volunteer">
                  <VolunteerUpdatePassword />
                </ProtectedRoute>
              }
            />

            {/* NEW universal user update password route */}
            <Route
              path="/user/update-password"
              element={
                <ProtectedRoute roleRequired={['master_admin','admin','accounts','trustee','graphics','volunteer']}>
                  <UserUpdatePassword />
                </ProtectedRoute>
              }
            />

            {/* Potentially you can remove or keep this: */}
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
